import z from "zod";
import type { FormInputSchemaParams } from "@/lib/types/form/form-field";

export default function emailZodSchema({ required }: FormInputSchemaParams) {
	return z.string().superRefine((value, ctx) => {
		const trimmed = value.trim();
		if (trimmed.length === 0) {
			if (required) {
				ctx.addIssue({ code: "custom", message: "required" });
			}
			return;
		}

		const result = z.email({ message: "invalidEmail" }).safeParse(trimmed);
		if (!result.success) {
			ctx.addIssue({ code: "custom", message: "invalidEmail" });
		}
	});
}
